import { TOGGLE_LOADER, CHANGE_PROGRESS } from "../mutations";

const system = {
  state: {
    loading: false,
    progressBarShow: false,
    currentPercent: 0,
    nextPercent: 0,
  },
  mutations: {
    [TOGGLE_LOADER](state, payload) {
      state.loading = payload.state;
    },
    [CHANGE_PROGRESS](state, payload) {
      state.progressBarShow = payload.progressBarShow;
      state.currentPercent = payload.currentPercent;
      state.nextPercent = payload.nextPercent;
    },
  },
  actions: {},
  getters: {}
};

export default system;
